import authSaga from './sagas/authSaga';

export default [
    authSaga
];